export default __webpack_public_path__ + "static/media/banner4.9b94889b.jpg";